import { render, staticRenderFns } from "./NewformUploadFile.vue?vue&type=template&id=dec20d56&scoped=true"
import script from "./NewformUploadFile.vue?vue&type=script&lang=js"
export * from "./NewformUploadFile.vue?vue&type=script&lang=js"
import style0 from "./NewformUploadFile.vue?vue&type=style&index=0&id=dec20d56&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec20d56",
  null
  
)

export default component.exports